import { render, staticRenderFns } from "./InstitutionPublishersList.vue?vue&type=template&id=96fabe52"
import script from "./InstitutionPublishersList.vue?vue&type=script&lang=js"
export * from "./InstitutionPublishersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports